/*! ******************************************************************************************************** *
 *
 * Copyright 2025 Oidis
 *
 * SPDX-License-Identifier: BSD-2-Clause
 * The BSD-2-Clause license for this file can be found in the LICENSE.txt file included with this distribution
 * or at https://spdx.org/licenses/BSD-2-Clause.html#licenseText
 *
 * ********************************************************************************************************* */

import { LRU } from "./LRU.js";
import { WorkerPool } from "./WorkerPool.js";

const PotreeSingleton = {
    workerPool: new WorkerPool(),
    lru: new LRU(),
    resolveQueries: () => {
        // TODO(mkelnar) no code found?
    }
};

export default PotreeSingleton;
